import { useTranslation } from "react-i18next"

import { Button, Flex, Icon, Text } from "components/common"
import { Separator } from "components/custom"
import theme from "utils/themeVars"

import styles from "./index.module.less"

const CTA_HREF = "https://www.myzameen.com"

const ZameenTopBanner = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.zameenTopBanner} role="region" aria-label="Zameen promotion">
      <Flex
        className="lhn w-100"
        align="center"
        justify="center"
        gap="16px"
        wrap={false}
      >
        <Icon icon="MyZameenLogo" aria-label="myzameen" />
        <Separator className="small" aria-hidden style={{ "--separator-color": theme["gray800"] }} />
        <Text className={styles.zameenTopBannerMessage} color="white">
          {t("Own Property in Pakistan from PKR 10,000")}
        </Text>
        <Separator className="small" aria-hidden style={{ "--separator-color": theme["gray800"] }} />
        <Button
          type="link"
          href={CTA_HREF}
          target="_blank"
          rel="noopener noreferrer"
          icon="FiExternalLink"
          text={t("Buy Now")}
          suffixIcon
          className="text-underline p-0"
          style={{ "--btn-color": "#0CF19E" }}
        />
      </Flex>
    </div>
  )
}

export default ZameenTopBanner
